import React from "react";

function WelcomeAllBizz({ width, height }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="522"
      height="176"
      viewBox="0 0 522 176"
    >
      <defs>
        <filter
          id="Ellipse_139"
          width="114"
          height="114"
          x="408"
          y="31"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dy="2"></feOffset>
          <feGaussianBlur result="blur" stdDeviation="4"></feGaussianBlur>
          <feFlood floodOpacity="0.122"></feFlood>
          <feComposite in2="blur" operator="in"></feComposite>
          <feComposite in="SourceGraphic"></feComposite>
        </filter>
        <filter
          id="Ellipse_139-2"
          width="144"
          height="144"
          x="307"
          y="16"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dy="2"></feOffset>
          <feGaussianBlur result="blur-2" stdDeviation="4"></feGaussianBlur>
          <feFlood floodOpacity="0.122"></feFlood>
          <feComposite in2="blur-2" operator="in"></feComposite>
          <feComposite in="SourceGraphic"></feComposite>
        </filter>
        <filter
          id="Ellipse_139-3"
          width="114"
          height="114"
          x="0"
          y="31"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dy="2"></feOffset>
          <feGaussianBlur result="blur-3" stdDeviation="4"></feGaussianBlur>
          <feFlood floodOpacity="0.122"></feFlood>
          <feComposite in2="blur-3" operator="in"></feComposite>
          <feComposite in="SourceGraphic"></feComposite>
        </filter>
        <filter
          id="Ellipse_139-4"
          width="144"
          height="144"
          x="72"
          y="16"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dy="2"></feOffset>
          <feGaussianBlur result="blur-4" stdDeviation="4"></feGaussianBlur>
          <feFlood floodOpacity="0.122"></feFlood>
          <feComposite in2="blur-4" operator="in"></feComposite>
          <feComposite in="SourceGraphic"></feComposite>
        </filter>
        <filter
          id="Ellipse_720"
          width="176"
          height="176"
          x="173"
          y="0"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dy="2"></feOffset>
          <feGaussianBlur result="blur-5" stdDeviation="4"></feGaussianBlur>
          <feFlood floodOpacity="0.122"></feFlood>
          <feComposite in2="blur-5" operator="in"></feComposite>
          <feComposite in="SourceGraphic"></feComposite>
        </filter>
      </defs>
      <g data-name="Group 8206" transform="translate(-90 -376)">
        <g data-name="Group 8197" transform="translate(19.88 -27.12)">
          <g data-name="Group 8605" transform="translate(490.12 444.12)">
            <g filter="url(#Ellipse_139)" transform="translate(-420 -41)">
              <circle
                cx="45"
                cy="45"
                r="45"
                fill="#fff"
                data-name="Ellipse 139"
                transform="translate(420 41)"
              ></circle>
            </g>
            <text
              data-name=""
              fontFamily="JioMoney"
              fontSize="32"
              transform="translate(29 59)"
            >
              <tspan x="0" y="0">
                
              </tspan>
            </text>
          </g>
          <g data-name="Group 8597" transform="translate(389.12 429.12)">
            <g filter="url(#Ellipse_139-2)" transform="translate(-319 -26)">
              <circle
                cx="60"
                cy="60"
                r="60"
                fill="#fff"
                data-name="Ellipse 139"
                transform="translate(319 26)"
              ></circle>
            </g>
            <text
              data-name=""
              fontFamily="JioMoney"
              fontSize="40"
              transform="translate(40 78)"
            >
              <tspan x="0" y="0">
                
              </tspan>
            </text>
          </g>
          <g data-name="Group 8604" transform="translate(82.12 444.12)">
            <g filter="url(#Ellipse_139-3)" transform="translate(-12 -41)">
              <circle
                cx="45"
                cy="45"
                r="45"
                fill="#fff"
                data-name="Ellipse 139"
                transform="translate(12 41)"
              ></circle>
            </g>
            <text
              data-name=""
              fontFamily="JioMoney"
              fontSize="32"
              transform="translate(29 59)"
            >
              <tspan x="0" y="0">
                
              </tspan>
            </text>
          </g>
          <g data-name="Group 8598" transform="translate(154.12 429.12)">
            <g filter="url(#Ellipse_139-4)" transform="translate(-84 -26)">
              <circle
                cx="60"
                cy="60"
                r="60"
                fill="#fff"
                data-name="Ellipse 139"
                transform="translate(84 26)"
              ></circle>
            </g>
            <text
              data-name=""
              fontFamily="JioMoney"
              fontSize="40"
              transform="translate(40 78)"
            >
              <tspan x="0" y="0">
                
              </tspan>
            </text>
          </g>
          <g data-name="Group 8595" transform="translate(255.12 413.12)">
            <g filter="url(#Ellipse_720)" transform="translate(-185 -10)">
              <circle
                cx="76"
                cy="76"
                r="76"
                fill="#fff"
                data-name="Ellipse 720"
                transform="translate(185 10)"
              ></circle>
            </g>
            <text
              data-name=""
              fontFamily="JioMoney"
              fontSize="56"
              transform="translate(48 97)"
            >
              <tspan x="0" y="0">
                
              </tspan>
            </text>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default WelcomeAllBizz;
